import React from 'react';
import styled from 'styled-components';
import { mobileMediaQuery, themeColor } from '../../../Theming';
import { SvgProps } from '../core';

const StyledSVG = styled.svg`
  color: ${themeColor('darkBlue')};
  ${mobileMediaQuery} {
    margin-left: 25px;
    width: 104px;
    height: 81.79px;
  }
`;

const BenefitTwo: React.FC<SvgProps> = ({
  width = 153,
  height = 114,
  className,
}) => {
  return (
    <StyledSVG
      width={width}
      height={height}
      className={className}
      viewBox="0 0 153 114"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M136.168 0H15.8349C7.10185 0 0.00158691 7.50929 0.00158691 16.7455V97.1237C0.00158691 106.36 7.10185 113.869 15.8349 113.869H136.168C144.901 113.869 152.002 106.36 152.002 97.1237V16.7455C152.002 7.50929 144.901 0 136.168 0ZM90.6598 51.61L73.1689 66.524L79.2548 89.5228C79.6012 90.8572 79.1435 92.2963 78.0797 93.1205C77.523 93.5522 76.8551 93.7746 76.1995 93.7746C75.6057 93.7746 75.012 93.5914 74.4924 93.2513L55.4182 80.2997L36.344 93.2513C35.2431 93.997 33.8206 93.9447 32.7568 93.1205C31.693 92.2963 31.2353 90.8572 31.594 89.5228L37.68 66.524L20.1767 51.61C19.1624 50.7335 18.7542 49.2945 19.1624 47.9731C19.5582 46.6518 20.6962 45.723 22.0074 45.6576L44.471 44.454L52.4618 22.2531C52.9319 20.958 54.107 20.0946 55.4182 20.0946C56.7294 20.0946 57.9046 20.958 58.3746 22.2531L66.3655 44.4409L88.829 45.6576C90.1402 45.723 91.2782 46.6387 91.6741 47.9601C92.0823 49.2945 91.6741 50.7335 90.6598 51.61ZM98.1682 90.4255C96.4241 90.4255 95.0015 88.921 95.0015 87.0764C95.0015 85.2318 96.4241 83.7273 98.1682 83.7273C99.9124 83.7273 101.335 85.2318 101.335 87.0764C101.335 88.921 99.9124 90.4255 98.1682 90.4255ZM107.668 90.4255C105.924 90.4255 104.502 88.921 104.502 87.0764C104.502 85.2318 105.924 83.7273 107.668 83.7273C109.412 83.7273 110.835 85.2318 110.835 87.0764C110.835 88.921 109.412 90.4255 107.668 90.4255ZM117.168 90.4255C115.424 90.4255 114.002 88.921 114.002 87.0764C114.002 85.2318 115.424 83.7273 117.168 83.7273C118.912 83.7273 120.335 85.2318 120.335 87.0764C120.335 88.921 118.912 90.4255 117.168 90.4255ZM126.668 90.4255C124.924 90.4255 123.502 88.921 123.502 87.0764C123.502 85.2318 124.924 83.7273 126.668 83.7273C128.412 83.7273 129.835 85.2318 129.835 87.0764C129.835 88.921 128.412 90.4255 126.668 90.4255Z"
        fill="currentColor"
      />
    </StyledSVG>
  );
};

export default BenefitTwo;
